import { jsx as s } from "react/jsx-runtime";
import o from "./index.es717.js";
import { FeedbackMessageItem as m } from "./index.es718.js";
const r = "feedback-component", p = ({
  feedback: t,
  testId: a = r
}) => /* @__PURE__ */ s("div", { className: o.container, "data-testid": a, children: t.map((e) => /* @__PURE__ */ s(m, { ...e }, e.message)) });
export {
  r as FEEDBACK_DEFAULT_TEST_ID,
  p as FeedbackMessage
};
//# sourceMappingURL=index.es40.js.map
